// extracted by mini-css-extract-plugin
export var pageTitleWrapper = "new-perspective-module--page-title-wrapper--TMlov";
export var previewSection = "new-perspective-module--preview-section--D6lZv";